import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { urlTransform } from "../../../hooks/ImageHook";
import { useTranslation } from 'react-i18next';
const ModalMobileImages = ({ images, model, category }) => {
    const [mainImage, setMainImage] = useState(images[0]);
    const { t } = useTranslation();
    const setBorderThumbnail = (index) => {
        var _a, _b;
        //put a border around the selected thumbnail
        (_a = document
            .getElementById("thumb_car_" + (index + 1))) === null || _a === void 0 ? void 0 : _a.classList.add("selected_thumbnail_image");
        //remove border from all other elements
        for (let i = 0; i < images.length; i++) {
            if (i != index) {
                (_b = document
                    .getElementById("thumb_car_" + (i + 1))) === null || _b === void 0 ? void 0 : _b.classList.remove("selected_thumbnail_image");
            }
        }
    };
    return (_jsxs("div", { className: "modal_car_images", children: [_jsx("div", { className: "modal_title_images", children: _jsx("div", { className: "model_name", id: "model_modal_image", children: _jsxs("div", { className: "model_info flex-item", id: "model_info_image", children: [_jsx("h6", { className: "s1 weight-700 cat_modal", children: category }), _jsx("p", { className: "s1 mark_note_modal", children: t("this_model") })] }) }) }), _jsx("div", { className: "modal_image_container", children: _jsx("img", { src: urlTransform(mainImage, 1000), alt: "Main Image", className: "main_image_modal", loading: "lazy" }) }), _jsx("div", { className: "thumbnails_modal_image", children: images.map((image, index) => (_jsx("img", { src: urlTransform(image), alt: `Thumbnail ${index + 1}`, onClick: () => {
                        setMainImage(image);
                        setBorderThumbnail(index);
                    }, className: "thumbnail_image", id: "thumb_car_" + (index + 1) }, index))) })] }));
};
export default ModalMobileImages;
